import {Translate} from "../Translate";
import {defaultVariabls} from "../index";

const topMenuRoutesConfig = [
  {
    id: 'homePage',
    title: Translate.homePage,
    type: 'item',
    url: `${defaultVariabls.website}`,
  },
    {
    id: 'articles',
    title: Translate.contents,
    type: 'item',
    url: `${defaultVariabls.website}/news`,
  },
    {
        id: 'shop',
        title: Translate.safecoins,
        type: 'item',
        url: `${defaultVariabls.website}/buy-fifa-coin`,
    },
];
export default topMenuRoutesConfig;
